// extracted by mini-css-extract-plugin
export default {"Textarea":"textarea_Textarea__SHjx1"};